import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface HotRankingProps {
  movies: Movie[];
}

export default function HotRanking({ movies }: HotRankingProps) {
  return (
    <section className="w-full px-4 md:px-6 py-6 md:py-8 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-5">
          <div>
            <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900">
              热门排行
            </h2>
            <p className="text-xs text-foreground-500 mt-1">本周最受欢迎的影视作品</p>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {movies.map((movie, index) => (
            <Link
              key={movie.id}
              to={`/article/${movie.id}`}
              className="group flex items-center gap-4 p-3 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-200 cursor-pointer"
            >
              <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center">
                <span
                  className={`text-base font-heading font-bold ${
                    index < 3 ? 'text-accent-500' : 'text-foreground-400'
                  }`}
                >
                  {String(index + 1).padStart(2, '0')}
                </span>
              </div>
              <div className="flex-shrink-0 w-14 h-20 rounded overflow-hidden bg-background-200">
                <img
                  src={movie.imageUrl}
                  alt={movie.title}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors truncate">
                  {movie.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1">
                  {movie.year} · {movie.region} · {movie.category === 'movie' ? '电影' : movie.category === 'tv' ? '电视剧' : movie.category === 'anime' ? '动漫' : movie.category === 'variety' ? '综艺' : movie.category === 'documentary' ? '纪录片' : '少儿'}
                </p>
                <div className="flex items-center gap-2 mt-1">
                  <span className="text-xs text-accent-500 font-medium">{movie.rating}分</span>
                  {movie.tags.slice(0, 2).map((tag) => (
                    <span key={tag} className="text-[10px] px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-700 whitespace-nowrap">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
              <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center">
                <i className="ri-play-circle-line text-xl text-foreground-400 group-hover:text-primary-500 transition-colors"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}